import { colors } from '@src/common/styles/valueTokens';
import { NoteContext } from '@src/notes/domain/NoteContext';

type Colors = {
  color: string;
  border: string;
  background: string;
};

export const noteStatusColor: Record<string, Colors> = {
  [NoteContext.error]: {
    color: colors.utility.error['700'],
    border: colors.utility.error['700'],
    background: 'transparent',
  },
  [NoteContext.onHold]: {
    color: colors.utility.warning['700'],
    border: colors.utility.warning['700'],
    background: 'transparent',
  },
  [NoteContext.finance]: {
    color: '#DD2590',
    border: '#DD2590',
    background: 'transparent',
  },
  [NoteContext.followUp]: {
    color: '#0086C9',
    border: '#0086C9',
    background: 'transparent',
  },
  [NoteContext.cancel]: {
    color: colors.neutralVariant['30'],
    border: colors.neutralVariant['30'],
    background: 'transparent',
  },
  [NoteContext.adjustments]: {
    color: '#dd8725',
    border: '#dd8125',
    background: 'transparent',
  },
  [NoteContext.client]: {
    color: colors.neutralVariant['30'],
    border: colors.neutralVariant['30'],
    background: 'transparent',
  },
};
